module.exports = __webpack_public_path__ + "img/wscgq.06b299eb.png";